/*
 * Created by: cparaschiv
 * Date: 23.04.2014, 17:19 
 */

(function ($, undefined) {
    'use strict';

    var kendo = window.kendo,
        ui = kendo.ui,
        Widget = ui.Widget,
        CHANGE = "change",
        ns = '.tsKendoEditable',
        helper = TS.widget.gridHelper;

    function createBindingString(handler, props) {
        var bindingStr;

        bindingStr = '{' + props.join(', ') + '}';

        return handler + ': ' + bindingStr;
    }

    function datePickerBinding(opts) {
        var props;

        props = [
            'value: ' + opts.PropertyName(),
            'mask: "99.99.9999"'
        ];

        //TODO: date picker does not accept time in format, remove
        if (opts.format) {
            props.push('format: "' + kendo._extractFormat(opts.format) + '"');
        }

        return createBindingString('kendoTsDatePicker', props);
    }

    function timePickerBinding(opts) {
        var props;

        props = [
            'value: ' + opts.PropertyName()
        ];

        if (opts.format) {
            props.push('format: "' + opts.format + '"');
        }

        return createBindingString('kendoTimePicker', props);
    }

    function numericBinding(opts) {
        var props,
            format;

        props = [
            'value: ' + opts.PropertyName(),
            'spinners: false',
            'decimals: ' + (opts.decimalPrecision || 0).toString()
        ];

        format = TS.Util.kendoNumericFormat(opts.decimalPrecision, opts.useThousandSeparator);
        if (format) {
            props.push('format: "' + format + '"');
        }

        if (opts && opts.listField) {
            var f = opts.listField;
            var minValue = TS.unwrap(f.minValue);
            var maxValue = TS.unwrap(f.maxValue);
            var allowNegative = TS.unwrap(f.allowNegative);

            if (!allowNegative || minValue) {
                props.push('min: ' + (!allowNegative ? (minValue > 0 ? minValue : 0) : minValue));
            }

            if (maxValue) {
                props.push('max: ' + maxValue);
            }
        }

        return createBindingString('kendoNumericTextBox', props);
    }

    function lookupBinding(opts) {
        var props;
        /*
         kendoTsLateFetchCombo: {
         selectionList: "PersonViewRender_SocialAddressViewRender_lkpDistrict_Property",
         value: Document.Client.SocialAddress.DistrictId,
         text: Document.Client.SocialAddress.DistrictName
         }
         */
        props = [
            'selectionList: "' + opts.propertyPath + '"',
            'value: ' + opts.PropertyName(),
            'text: ' + ko.valueOf(opts.DisplayPropertyName)
        ];

        return createBindingString('kendoTsLateFetchCombo', props);
    }

    function browseBinding(opts) {
        /*
         kendoTsBrowsePicker: {
         browseList: 'browseCtrl_Property',
         value: Document.DummyTask.TaskId,
         text: Document.DummyTask.TaskName
         }
         */
        var props;
        props = [
            'browseList: "' + opts.propertyPath + '"',
            'value: ' + opts.PropertyName(),
            'text: ' + (opts.DisplayPropertyName() || opts.PropertyName()),
            'embedded: true',
            'allowInput: ' + (opts.allowInput || false),
        ];

        return createBindingString('kendoTsBrowsePicker', props);

    }

    function createAttributes(opts) {
        var BINDING = kendo.attr("bind"),
            attr = {
                name: opts.Name
            },
            type = helper.getEditorType(opts.type),
            bindingStr;

        switch (type) {
            case 'text':
            case 'textarea':
                bindingStr = 'value: ' + opts.PropertyName();
                break;

            case 'bool':
                bindingStr = 'checked: ' + opts.PropertyName();
                break;

            case 'date':
                bindingStr = datePickerBinding(opts);
                break;

            case 'time':
                bindingStr = timePickerBinding(opts);
                break;

            case 'numeric':
                bindingStr = numericBinding(opts);
                break;

            case 'selection':
            case 'adaptiveLookup':
                bindingStr = lookupBinding(opts);
                break;

            case 'browse':
                bindingStr = browseBinding(opts);
                break;

            default:
                TS.log('Unknown field type');
                break;
        }

        attr[BINDING] = bindingStr;
        return attr;
    }

    var editors = {
        'text': {
            create: function (container, options) {
                var attr = createAttributes(options),
                    $input,
                    maxLen = '';

                if (options.MaxLength > 0) {
                    maxLen = 'maxLength="' + options.MaxLength + '"';
                }

                $input = $('<input type="text" class="k-input k-textbox" ' + maxLen + '/>').attr(attr);
                $input.appendTo(container);

                return $input;
            },

            update: function (editor, onKeyUp) {
                editor.focus().select();
                onKeyUp && editor.on("keyup" + ns, onKeyUp);
            }
        },

        'textarea': {
            create: function (container, options) {
                var attr = createAttributes(options),
                    $input,
                    maxLen = '';

                if (options.MaxLength > 0) {
                    maxLen = 'maxLength="' + options.MaxLength + '"';
                }

                $input = $('<textarea class="k-input k-textbox" ' + maxLen + '></textarea>').attr(attr);
                $input.appendTo(container);

                return $input;
            },

            update: function (editor, onKeyUp) {
                editor.focus().select();
                onKeyUp && editor.on("keyup" + ns, onKeyUp);
            }
        },

        'numeric': {
            create: function (container, options) {
                var attr = createAttributes(options),
                    $input;

                $input = $('<input type="number" class="k-input k-textbox"/>').attr(attr);
                $input.appendTo(container);

                return $input;
            },

            update: function (editor, onKeyUp) {
                var actualInput = editor.siblings('input').first();

                actualInput.length && actualInput.focus();

                onKeyUp && editor.one("keydown" + ns, onKeyUp);
            }
        },

        'date': {
            create: function (container, options) {
                var attr = createAttributes(options),
                    format = options.format,
                    $input;

                $input = $('<input type="text" class="k-input k-textbox"/>').attr(attr);
                $input.appendTo(container);

                return $input;
            },

            update: function (editor, onKeyUp) {
                var widget;
                editor.focus().select();

                onKeyUp && editor.on("keyup" + ns, onKeyUp);

                widget = editor.data('kendoTsDatePicker');
                return widget;
            }
        },

        'time': {
            create: function (container, options) {
                var attr = createAttributes(options),
                    format = options.format,
                    $input;

                $input = $('<input type="text" class="k-input k-textbox"/>').attr(attr);
                $input.appendTo(container);

                return $input;
            },

            update: function (editor, onKeyUp) {
                var widget;

                editor.focus().select();

                onKeyUp && editor.on("keyup" + ns, onKeyUp);

                widget = editor.data('kendoTimePicker');
                return widget;
            }
        },

        'adaptiveLookup': {
            create: function (container, options) {
                var attr = createAttributes(options),
                    $input;

                $input = $('<input type="text" class="k-input k-textbox"/>').attr(attr);
                $input.appendTo(container);

                return $input;
            },

            update: function (editor, onKeyUp, record, options, parentVm) {
                var widget = editor.data('kendoTsLateFetchCombo'),
                    propName,
                    sl;

                propName = options.propertyPath;
                sl = parentVm && TS.getPropertyValue(parentVm, propName);
                if (sl) {
                    //sl.allowEmptySelection = false;
                    sl._targetModel = record;
                    widget._setSelectionList(sl);
                } else {
                    TS.Log.error('Cannot find lookupProperty/selectionProperty name [' + propName + ']');
                }

                return widget;
            },

            destroy: function (editor, widget, record, options, parentVm) {
                widget.close();
                widget.destroy();
                widget.destroy = $.noop;
            }
        },

        'browse': {
            create: function (container, options, record, parentVm) {
                var attr = createAttributes(options),
                    $input;

                $input = $('<input type="text" class="k-input k-textbox"/>').attr(attr);
                $input.appendTo(container);

                return $input;
            },

            update: function (editor, onKeyUp, record, options, parentVm) {
                var widget = editor.data('kendoTsBrowsePicker'),
                    propName = options.propertyPath,
                    browseProperty = parentVm && TS.getPropertyValue(parentVm, propName);

                if (browseProperty) {
                    browseProperty._targetModel = record;
                    widget.browseProperty = browseProperty;
                } else {
                    TS.Log.error('Cannot find lookupProperty/selectionProperty name [' + propName + ']');
                }

                return widget;
            }
        }
    };

    editors['selection'] = editors['adaptiveLookup'];

    var koEditable = Widget.extend({

        events: [CHANGE, 'escapePressed', 'enterPressed'],

        options: {
            name: 'KoEditable',
            clearContainer: true
        },

        _widget: null,
        _ended: false,

        init: function (element, opts) {
            var me = this;

            Widget.fn.init.call(me, element, opts);
            me._record = opts.model;

            me._uid = TS.newUID();
            me.refresh();
        },

        getWidget: function () {
            return this._widget;
        },

        _getEditor: function () {
            var me = this,
                cfg = helper.getCfg(me.options.cfg, me._record),
                editorType = helper.getEditorType(cfg.type);

            if (!editors[editorType]) {
                TS.Log.error('Grid edit - cannot find editor for type: ' + editorType);
                return;
            }

            return editors[editorType];
        },

        _createEditor: function (container, opts) {
            var me = this,
                editor = me._getEditor(),
                cfg = helper.getCfg(me.options.cfg, me._record);

            me._editor = editor && editor.create(container, cfg, me._record, me.options.parentViewModel);
        },

        _updateEditor: function () {
            var me = this,
                editor = me._getEditor(),
                cfg = helper.getCfg(me.options.cfg, me._record);

            if (!me._editor || !editor) {
                return;
            }

            me._widget = editor.update(me._editor, $.proxy(me._keyup, me), me._record, cfg, me.options.parentViewModel);
            //me._widget.bind('change', $.proxy(me.end, me));
            if (me._widget) {
                me._widget.bind('close', $.proxy(me.end, me));
            }
            me._backupEvents();
        },

        _destroyEditor: function () {
            var me = this,
                editor = me._getEditor(),
                cfg = helper.getCfg(me.options.cfg, me._record);

            if (!me._editor || !editor) {
                return;
            }

            // notify editor that will be destroyed
            // the drop-down must call its 'close' method that will notify the knockout binding handler
            // which will also update text (not only value)
            editor.destroy && editor.destroy(me._editor, me._widget, me._record, cfg, me.options.parentViewModel);
            delete me._editor;
        },

        _keyup: function (e) {
            var me = this,
                enterPressed = (e.keyCode == kendo.keys.ENTER),
                isTextArea = (e.target.nodeName === 'TEXTAREA'),
                doBlur;

            if (e.keyCode == kendo.keys.ESC) {
                me.trigger('escapePressed');
            }

            // force element to lose focus, will trigger the 'change' (DOM) event
            // and knockout will notify subscribers that value has changed
            if (enterPressed) {
                doBlur = isTextArea ? e.ctrlKey : true; //for TextArea, blur on Ctrl + Enter (Enter creates a new line)
                if (doBlur) {
                    e.target && $(e.target).blur();
                    me.trigger('enterPressed');
                }
            }
        },

        _backupEvents: function () {
            var me = this;
            me._eventsBackup = me._events;
        },

        _restoreEvents: function () {
            var me = this;
            if ($.isEmptyObject(me._events) && !$.isEmptyObject(me._eventsBackup)) {
                me._events = me._eventsBackup;
            }
        },

        end: function () {
            var me = this;

            if (me._ended) {
                return true;
            }

            me._ended = true;
            me._restoreEvents();
            //me.trigger('endEdit');

            return true;
        },

        destroy: function () {
            var me = this;

            me._destroyEditor();
            Widget.fn.destroy.call(me);

            kendo.destroy(me.element);
            ko.cleanNode(me.element[0]);
            //ko.utils.domData.clear(me.element[0]);
        },

        refresh: function () {
            var me = this,
                opts = me.options,
                container = me.element.empty();

            me._createEditor(container, opts);
            ko.applyBindings(opts.model, container[0]);
            me._updateEditor();
        }
    });

    ui.plugin(koEditable);

})(jQuery);